module.exports = __webpack_public_path__ + "img/dark.96d3da49.svg";